import React from "react";
import {
  ClientData,
  ConfigurationExchangeInfo,
  OpenConfirmModal,
} from "@shared/types";
import { ConnectExchangeTabs } from "@shared/features/portfolio/types";

export const AccountFormContext = React.createContext<
  | {
      createAccountDrawerOpen: boolean;
      openCreateAccountDrawer: () => void;
      closeCreateAccountDrawer: () => void;
      exchangesData?: ConfigurationExchangeInfo[];
      exchangesLoading: boolean;
      aggExchanges: Record<string, ConfigurationExchangeInfo[]>;
      tab?: ConnectExchangeTabs;
      setTab: (tab?: ConnectExchangeTabs) => void;
      isDemoWorkspace: boolean;
      selectedSubExchanges?: ConfigurationExchangeInfo[];
      setSelectedSubExchanges: (
        exchanges?: ConfigurationExchangeInfo[]
      ) => void;
      accountName?: string;
      setAccountName: (accountName?: string) => void;
      resetFormValues: () => void;
      exchangeToClientName?: Record<string, string>;
      getSelectedSubExchangesData: (
        selectedSubExchanges?: string[]
      ) => ConfigurationExchangeInfo[] | undefined;
      getSubExchanges: (
        exchangeToClientName: Record<string, string>
      ) => ConfigurationExchangeInfo[] | undefined;
      handleOnSubmit: (
        primaryExchange: string | undefined,
        onSubmit: () => void,
        openConfirmModal: OpenConfirmModal<any>
      ) => void;
      accountNameError: boolean;
      setAccountNameError: (error: boolean) => void;
      getAccountSubExchange: (
        account?: ClientData
      ) => ConfigurationExchangeInfo | undefined;
      addClientSucceeded: boolean;
      setAddClientSucceeded: (succeeded: boolean) => void;
    }
  | undefined
>(undefined);
